angular.module('rjmNg.directives').directive "metricTimeOptions", [
  "timeRangeEnums"
  (
    timeRangeEnums
  ) ->
    restrict: "E"
    templateUrl: "directive.metricTimeOptions.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      metric: "="
      globalTimeInterval: "="
      checkIfCohortDisabled: "="
      updateReport: "="
      popover: '='
    controller: [
      "$scope"
      (
        $scope
      ) ->
        view = @

        view.TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES
        view.intervalsToShow = [view.TIME_INTERVAL_VALUES.NONE, view.TIME_INTERVAL_VALUES.GLOBAL]

        view.checkIfTimeOptionsChanged = () ->
          if (view.timeUnbound isnt !!view.metric.timeUnbound) or \
             (view.hasCustomTimeRange isnt !!view.metric.hasCustomTimeRange) or \
             (view.hasCustomTimeRange is true and !!view.metric.hasCustomTimeRange is true and view.timeRangeChanged)
            view.metric.timeOptionsChanged = true
          else
            view.metric.timeOptionsChanged = false

        view.restoreTimeOptions = () ->
          view.timeUnbound = !!view.metric.timeUnbound
          view.inputTimeInterval = if view.timeUnbound then view.TIME_INTERVAL_VALUES.NONE else view.TIME_INTERVAL_VALUES.GLOBAL
          $scope.$broadcast('initializeTimeRange')
          view.timeRangeValid = true
          view.timeRangeChanged = false
          view.hasCustomTimeRange = !!view.metric.hasCustomTimeRange
          view.checkIfTimeOptionsChanged()

        view.setTimeUnbound = () ->
          if view.metric.timeUnbound isnt view.timeUnbound
            view.metric.timeUnbound = view.timeUnbound
            view.metric.plot = not view.timeUnbound

        view.setCustomTimeRange = () ->
          view.metric.hasCustomTimeRange = view.hasCustomTimeRange
          view.metric.customTimeRange = if view.hasCustomTimeRange then view.timeRange else null

        view.apply = () ->
          view.setTimeUnbound()
          view.setCustomTimeRange()
          view.popover.hide()

          if view.checkIfCohortDisabled?
            view.checkIfCohortDisabled()

          if view.updateReport?
            view.updateReport()

        view.cancel = () ->
          view.popover.hide()

        view.cleanUp = () ->
          view.metric.timeOptionsChanged = false
          return

        view.$onInit = () ->
          view.restoreTimeOptions()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watchGroup [
        "view.timeUnbound"
        "view.metric.timeUnbound"
        "view.timeRangeChanged"
        "view.hasCustomTimeRange"
        ],
        view.checkIfTimeOptionsChanged

      scope.$on('$destroy', view.cleanUp)

      scope.$watch('view.outputTimeInterval', (newTimeInterval, oldTimeInterval) ->
        if newTimeInterval isnt oldTimeInterval
          if newTimeInterval is view.TIME_INTERVAL_VALUES.NONE
            view.timeUnbound = true
          else if view.TIME_INTERVAL_VALUES.GLOBAL
            view.timeUnbound = false
            view.hasCustomTimeRange = false
      )

      scope.$watch('view.popover.visible', (newVisibility, oldVisibility) ->
        if newVisibility is false and view.metric.timeOptionsChanged
          view.restoreTimeOptions()
      )
]
